// extracted by mini-css-extract-plugin
module.exports = {"main":"Payment_main__vcNlr","loading":"Payment_loading__FTqTQ","check":"Payment_check__2KqIQ"};